import React from 'react';
import { CouponCreateMutation } from '../graphql/mutations/CouponCreateMutation';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/Coupon.json';
import inputTypeIntro from '../static/introspection/CouponCreateInput.json';
import { CouponEditQuery } from '../graphql/query/CouponEditQuery';
import { ENTITY } from '../utils/entities';
import { graphqlQuery } from '../utils/graphql';
import { EntityCreatePage } from '../types/entities';
import { Coupon } from '../server-types';

export const CouponCreate: React.FC<EntityCreatePage<Coupon>> = ({ id }) => (
	<EntityEditFetcher
		fetcher={id ? graphqlQuery(CouponEditQuery, { id }) : null}
		create={true}
		clone={!!id}
		id={id}
		mutation={CouponCreateMutation}
		typeIntro={typeIntro}
		inputTypeIntro={inputTypeIntro}
		entityName={ENTITY.COUPON}
		fields={[
			'name',
			// 'type',
			'amount',
			'startDate',
			'expirationDate',
			'maxUsages',
			'maxUsagesPerQuote',
			'usagesCount',
			'brandSf',
			'product2Sf',
			'brandAreaSf'
		]}
	/>
);
